import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false,
})
export class NotFoundComponent {
  constructor(private router: Router) {}

  goHome() {
    // Redireciona para a raiz.
    // O LoginGuard vai interceptar se não estiver logado.
    // O AuthGuard/LoginGuard manda pra home se estiver logado.
    this.router.navigate(['/']);
  }
}
